import React, { useEffect, useState } from "react";
import { Shield, Chrome, Monitor, Smartphone, Globe, Mail } from "lucide-react";
import { api } from "@/lib/api";

function parseUA(ua = "") {
  const s = ua.toLowerCase();
  let browser = "Browser";
  if (s.includes("edg/")) browser = "Edge";
  else if (s.includes("chrome/") && !s.includes("edg/")) browser = "Chrome";
  else if (s.includes("safari/") && !s.includes("chrome/")) browser = "Safari";
  else if (s.includes("firefox/")) browser = "Firefox";
  let os = "Unknown OS";
  if (s.includes("windows")) os = "Windows";
  else if (s.includes("mac os") || s.includes("macintosh")) os = "macOS";
  else if (s.includes("android")) os = "Android";
  else if (s.includes("iphone") || s.includes("ipad") || s.includes("ios")) os = "iOS";
  else if (s.includes("linux")) os = "Linux";
  const mobile = /mobi|android|iphone|ipad/.test(s);
  return { browser, os, mobile };
}

export default function SignInLog() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/my/logins", { params: { limit: 8 } }).then(({ data }) => setItems(data)).catch(() => setItems([])); }, []);
  if (items === null) return null;

  return (
    <div className="glass rounded-2xl p-6" data-testid="signin-log">
      <div className="flex items-center gap-2 mb-1">
        <Shield className="w-4 h-4 text-gold" />
        <h2 className="font-display text-xl font-bold text-ink-900">Recent sign-ins</h2>
      </div>
      <p className="text-xs text-ink-500 mb-4">If you don't recognise any of these, change your password immediately.</p>
      {items.length === 0 ? (
        <p className="text-sm text-ink-500">No sign-in history yet.</p>
      ) : (
        <ul className="divide-y divide-ink-900/10" data-testid="signin-log-list">
          {items.map((it, i) => {
            const { browser, os, mobile } = parseUA(it.user_agent || "");
            const Icon = mobile ? Smartphone : browser === "Chrome" || browser === "Edge" ? Chrome : Monitor;
            const when = new Date(it.created_at);
            return (
              <li key={it.history_id} className="py-3 flex items-center gap-4" data-testid={`signin-log-item-${i}`}>
                <div className="w-9 h-9 rounded-full bg-cream-100 border border-ink-900/10 flex items-center justify-center shrink-0">
                  <Icon className="w-4 h-4 text-ink-700" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm text-ink-900">
                    {browser} on {os}
                    {i === 0 && <span className="ml-2 text-[10px] uppercase tracking-wider px-1.5 py-0.5 rounded-full bg-gold/15 text-gold-800 border border-gold/30">Current</span>}
                  </div>
                  <div className="text-xs text-ink-500 flex items-center gap-3 mt-0.5">
                    <span>{when.toLocaleString()}</span>
                    {it.ip && <span className="inline-flex items-center gap-1"><Globe className="w-3 h-3" />{it.ip}</span>}
                    <span className="inline-flex items-center gap-1 uppercase tracking-wider">
                      {it.provider === "google" ? <><Chrome className="w-3 h-3" />Google</> : <><Mail className="w-3 h-3" />Email</>}
                    </span>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
